module.exports = __webpack_public_path__ + "images/accents/accent-sl3-responsive-6d9dbb6031cb8529c84883a86ce662d0.webp";